<template>
    <div class="table-responsive">
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th>
                        <b-form-checkbox
                            v-if="isBulkRemove"
                            v-model="selectAll"
                            @change="toggleAll"
                            plain
                        >
                        </b-form-checkbox
                    ></b-th>
                    <b-th>Item:</b-th>
                    <b-th>Patient:</b-th>
                    <b-th>Provider:</b-th>
                    <b-th>Quantity:</b-th>
                    <b-th>Price:</b-th>
                    <b-th>Discount:</b-th>
                    <b-th>Tax:</b-th>
                    <b-th>Line Total:</b-th>
                    <b-th>Print:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="estimateItems.length == 0">
                <b-tr>
                    <td colspan="11">
                        <i>No records available</i>
                    </td>
                </b-tr>
            </b-tbody>
            <draggable
                v-else
                v-model="estimateItems"
                tag="tbody"
                ghost-class="sort-row-ghost"
                drag-class="sort-row-drag"
                :animation="0"
                handle=".handle"
                @start="isRowDragging = true"
                @end="isRowDragging = false"
                @sort="itemSorted"
            >
                <tr
                    v-for="estimateItem in estimateItems"
                    :key="estimateItem.id"
                >
                    <td :class="{ handle: !isBulkRemove }">
                        <span v-if="isBulkRemove">
                            <b-form-checkbox
                                v-if="
                                    'declineDeleteItem' in estimateItem &&
                                    _hasAccess('billing.invoice.item.delete') &&
                                    (bulkRemoveType == 'decline'
                                        ? estimateItem.canDeclineItem
                                        : estimateItem.canDeleteItem)
                                "
                                v-model="estimateItem.declineDeleteItem"
                                @change="checkboxChange"
                                plain
                            >
                            </b-form-checkbox>
                        </span>
                        <span
                            v-else
                            :id="`item_${estimateItem.id}`"
                            class="cus-black-white-swatch cursor-move disable-touch-select"
                        ></span>
                    </td>
                    <td>
                        <span>
                            {{ estimateItem.item.name }}
                            <span
                                v-if="
                                    estimateItem.item.type !=
                                    CITEMTYPES.TYPES.TYPE_DISCOUNT
                                "
                                class="text-nowrap"
                            >
                                ({{ _setDateDisplay(estimateItem.date) }})</span
                            >
                        </span>
                    </td>
                    <td>
                        <patient-name
                            v-if="estimateItem.patient"
                            :patient="estimateItem.patient"
                        />
                    </td>
                    <td>
                        <span>
                            {{ displayProvider(estimateItem) }}
                        </span>
                    </td>
                    <td>
                        {{ displayQuantity(estimateItem) }}
                    </td>
                    <td class="text-nowrap">
                        <span
                            v-if="
                                estimateItem.item &&
                                estimateItem.item.type !=
                                    CITEMTYPES.TYPES.TYPE_DISCOUNT
                            "
                        >
                            {{ displayPrice(estimateItem) }}
                        </span>
                    </td>
                    <td class="text-nowrap">
                        {{ displayDiscount(estimateItem) }}
                    </td>
                    <td>
                        <span
                            v-if="
                                estimateItem.item &&
                                estimateItem.item.type !=
                                    CITEMTYPES.TYPES.TYPE_DISCOUNT
                            "
                        >
                            {{ displayTax(estimateItem) }}
                        </span>
                    </td>
                    <td>{{ displayLineTotal(estimateItem) }}</td>
                    <td>
                        {{ estimateItem.print_on_estimate == 1 ? "Yes" : "No" }}
                    </td>
                    <td class="text-right">
                        <!-- ONLY CHECKING IN DECLINED LIST (FROM CI) -->
                        <!-- v-if="
                        _hasAccess('billing.estimate.item.insert') && !estimate.isapprove && isBusinessActorActive
                            estimate.isBusinessActorActive && estimateItem.item
                        " -->
                        <span
                            v-if="
                                (_hasAccess('billing.estimate.item.update') ||
                                    _hasAccess(
                                        'billing.estimate.item.decline'
                                    ) ||
                                    _hasAccess(
                                        'billing.estimate.item.delete'
                                    )) &&
                                !estimate.isapprove &&
                                (estimate.client ? isBusinessActorActive : true)
                            "
                        >
                            <b-dropdown
                                v-if="
                                    estimateItem.item.type !=
                                    CITEMTYPES.TYPES.TYPE_DISCOUNT
                                "
                                variant="link"
                                toggle-class="text-decoration-none"
                                no-caret
                                right
                                title="Additional options"
                            >
                                <template v-slot:button-content>
                                    <i class="cus-cog-down"></i>
                                </template>

                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'billing.estimate.item.update'
                                        )
                                    "
                                    href="#"
                                    @click="editItem(estimateItem)"
                                >
                                    <i class="cus-page-white-edit"></i>
                                    Edit Item
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'billing.estimate.item.decline'
                                        )
                                    "
                                    href="#"
                                    @click="declinedItem(estimateItem)"
                                >
                                    <i class="cus-page-delete"></i>
                                    Decline Item
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'billing.estimate.item.delete'
                                        )
                                    "
                                    href="#"
                                    @click="deleteItem(estimateItem)"
                                >
                                    <i class="cus-delete"></i>
                                    Delete Item
                                </b-dropdown-item>
                            </b-dropdown>

                            <!-- FOR ESTIMATE ITEM TYPE DISCOUNT -->
                            <i
                                v-else-if="
                                    estimateItem.item.type ==
                                        CITEMTYPES.TYPES.TYPE_DISCOUNT &&
                                    _hasAccess('billing.estimate.item.delete')
                                "
                                @click="deleteItem(estimateItem)"
                                class="cus-delete cursor-pointer"
                            ></i>
                        </span>
                    </td>
                </tr>
            </draggable>
        </b-table-simple>
        <modal-decline-item
            ref="modalDeclineItem"
            modalRef="modalDeclineItem"
            @reload="reloadRelated"
        />
        <modal-delete-estimate-item
            ref="modalDeleteEstimateItem"
            modalRef="modalDeleteEstimateItem"
            @reload="reloadRelated()"
        />
        <estimate-item-modal
            ref="estimateItemModal"
            @reload="reloadRelated"
            :isInvoice="false"
        />
        <modal-decline-in-bulk
            ref="modalBulkDecline"
            modalRef="modalBulkDecline"
            @reload="reloadRelated"
            :estimateItems="estimateItems"
        />
        <modal-delete-in-bulk
            ref="modalBulkDelete"
            modalRef="modalBulkDelete"
            @reload="reloadRelated"
            :estimateItems="estimateItems"
        />
    </div>
</template>

<script>
/**
 * @name EstimateItemList
 * @description List of Estimate Item
 * @see apps/application/views/staff/billing/invoice/estimate/sub/item/list.php
 */
import { uniqBy, filter, find, round, forEach } from "lodash";
import EstimateItemService from "@/services/estimate/estimate-item";
import Relationships from "@/services/patient-relationships.js";
import CITEMTYPES from "@/constants/item-types";
import CBILLINGS from "@/constants/billings";

export default {
    mixins: {},
    components: {
        Loader: () => import("@/components/elements/loader-list"),
        draggable: () => import("vuedraggable"),
        PatientName: () => import("@/components/commons/patient-name"),
        ModalDeclineItem: () =>
            import("@/components/estimate-item/item-decline-modal"),
        ModalDeleteEstimateItem: () =>
            import("@/components/estimate-item/modal-delete-estimate-item"),
        ModalDeclineInBulk: () =>
            import(
                "@/components/estimate-item/modal-bulk-decline-estimate-items"
            ),
        ModalDeleteInBulk: () =>
            import(
                "@/components/estimate-item/modal-bulk-delete-estimate-items"
            ),
        EstimateItemModal: () =>
            import("@/components/invoice-item/create-update")
    },
    props: {
        estimate: {
            type: Object,
            required: true
        },
        isBulkRemove: {
            type: Boolean,
            default: false
        },
        bulkRemoveType: {
            type: String,
            default: "decline"
        }
    },
    computed: {
        isBusinessActorActive() {
            return (
                this.estimate.client &&
                this.estimate.client.single_business_actor &&
                this.estimate.client.single_business_actor.isactive
            );
        }
    },
    watch: {
        async estimateItems(items) {
            let self = this;
            let otherClients = [];
            for (let item of items) {
                let patient = item.patient;
                if (patient && patient.isactive) {
                    let clients = await Relationships.getRelationships(
                        patient.id
                    );
                    clients = filter(
                        clients.resources,
                        client => "actor" in client
                    ).map(client => client.actor);
                    otherClients.push(...clients);
                }
            }
            let originalClient = find(
                otherClients,
                client => client.id == self.estimate.client_id
            );
            let clients = uniqBy(otherClients, client => client.id);
            this.$store.commit(
                "billing/setAvailableClients",
                clients.length <= 2 ? clients : [originalClient]
            );
        },
        isBulkRemove() {
            this.estimateItems = forEach(this.estimateItems, item => {
                item.declineDeleteItem = false;
            });
            this.checkboxChange();
        }
    },
    data() {
        return {
            CITEMTYPES: CITEMTYPES,
            CBILLINGS: CBILLINGS,
            isLoading: false,
            showPagination: false,
            estimateItems: [],
            selectedItem: null,
            isRowDragging: false,
            item: {},
            selectAll: false
        };
    },
    mounted() {
        // to disable the menu when the user long press on the icon
        $(document).on("contextmenu", ".handle", event => {
            event.preventDefault();
            event.stopPropagation();
            return false;
        });
        this.getEstimateItems();
    },
    destroyed() {
        $(document).off("contextmenu", ".handle");
    },
    methods: {
        async toggleAll(checked) {
            forEach(this.estimateItems, iitem => {
                if (this.bulkRemoveType == "decline") {
                    if (iitem.canDeclineItem) {
                        iitem.declineDeleteItem = checked;
                    }
                } else {
                    if (iitem.canDeleteItem) {
                        iitem.declineDeleteItem = checked;
                    }
                }
            });

            this.checkboxChange();
        },
        displayProvider(estimateItem) {
            if (estimateItem.provider) {
                return estimateItem.provider.display_name;
            } else if (
                estimateItem.default_provider &&
                estimateItem.default_provider.id &&
                estimateItem.prescribed_by == estimateItem.default_provider.id
            ) {
                return (
                    estimateItem.default_provider.business.name + " Provider"
                );
            }
            return "";
        },
        getEstimateItems() {
            let self = this;
            this.isLoading = true;
            this.selectAll = false;

            EstimateItemService.getEstimateItems(this.estimate.id).then(res => {
                self.isLoading = false;
                self.estimateItems = forEach(res, iitem => {
                    iitem.declineDeleteItem = false;
                    iitem.canDeclineItem = false;
                    iitem.canDeleteItem = false;

                    if (iitem.item.type != CITEMTYPES.TYPES.TYPE_DISCOUNT) {
                        iitem.canDeclineItem =
                            this._hasAccess("billing.estimate.item.decline") &&
                            !this.estimate.isapprove &&
                            (this.estimate.client
                                ? this.isBusinessActorActive
                                : true);

                        iitem.canDeleteItem =
                            this._hasAccess("billing.estimate.item.delete") &&
                            !this.estimate.isapprove &&
                            (this.estimate.client
                                ? this.isBusinessActorActive
                                : true);
                    } else {
                        iitem.canDeleteItem =
                            this._hasAccess("billing.estimate.item.delete") &&
                            !this.estimate.isapprove &&
                            (this.estimate.client
                                ? this.isBusinessActorActive
                                : true);
                    }
                });
                self.checkboxChange();
            });
        },
        checkboxChange() {
            this.$nextTick(() => {
                let bulkRemoveType =
                    this.bulkRemoveType === "decline"
                        ? { canDeclineItem: true }
                        : { canDeleteItem: true };
                let listSelected = filter(
                    this.estimateItems,
                    "declineDeleteItem"
                );
                this.selectAll =
                    listSelected.length ==
                    filter(this.estimateItems, bulkRemoveType).length;
                this.$emit("is-item-selected", listSelected.length);
            });
        },
        displayQuantity(estimateItem) {
            const uom = estimateItem.item_uom
                ? estimateItem.item_uom.value
                : "";
            if (
                estimateItem.quantity_max > 0 &&
                estimateItem.quantity_min != estimateItem.quantity_max
            ) {
                return `${estimateItem.quantity_min} - ${estimateItem.quantity_max} ${uom}`;
            }
            return `${estimateItem.quantity_min} ${uom}`;
        },
        displayPrice(estimateItem) {
            let calculatedPriceMin = 0;
            if (
                estimateItem.print_on_estimate &&
                estimateItem.quantity_min > 0
            ) {
                calculatedPriceMin =
                    parseFloat(estimateItem.price_min) +
                    parseFloat(estimateItem.fee);
            }

            let calculatedPriceMax = 0;
            if (estimateItem.print_on_estimate && estimateItem.price_max != 0) {
                calculatedPriceMax =
                    parseFloat(estimateItem.price_max) +
                    parseFloat(estimateItem.fee);
            }
            if (
                calculatedPriceMin != calculatedPriceMax &&
                calculatedPriceMax != 0 &&
                calculatedPriceMax != null &&
                estimateItem.quantity_max > 0
            ) {
                return `${this._toCurrency(
                    round(calculatedPriceMin, 2)
                )} - ${this._toCurrency(round(calculatedPriceMax, 2))}`;
            }
            return this._toCurrency(round(calculatedPriceMin, 2));
        },
        displayTax(estimateItem) {
            if (
                estimateItem.tax_max != 0 &&
                estimateItem.tax_max != null &&
                estimateItem.tax_min != estimateItem.tax_max &&
                estimateItem.quantity_max > 0
            ) {
                return `${this._toCurrency(
                    estimateItem.tax_min
                )} - ${this._toCurrency(estimateItem.tax_max)}`;
            } else {
                return this._toCurrency(estimateItem.tax_min || 0);
            }
        },
        displayLineTotal(estimateItem) {
            let lineTotalMin = 0,
                displayRange = false;
            if (estimateItem.quantity_min > 0) {
                lineTotalMin = this.calculateLineTotal(
                    estimateItem,
                    round(estimateItem.discount_min, 2),
                    round(estimateItem.price_min, 2),
                    round(estimateItem.tax_min, 2)
                );
            }

            let lineTotalMax = 0;
            if (estimateItem.price_max != 0) {
                lineTotalMax = this.calculateLineTotal(
                    estimateItem,
                    round(estimateItem.discount_max, 2),
                    round(estimateItem.price_max, 2),
                    round(estimateItem.tax_max, 2)
                );
            }
            if (
                lineTotalMin != lineTotalMax &&
                lineTotalMax != 0 &&
                lineTotalMax != null &&
                estimateItem.quantity_max > 0
            ) {
                displayRange = true;
            }
            lineTotalMin = this._toCurrency(lineTotalMin);
            lineTotalMax = this._toCurrency(lineTotalMax);
            if (estimateItem.item.type == CITEMTYPES.TYPES.TYPE_DISCOUNT) {
                lineTotalMin = `(${lineTotalMin})`;
                lineTotalMax = `(${lineTotalMax})`;
            }
            if (displayRange) {
                return lineTotalMin + " - " + lineTotalMax;
            }
            return lineTotalMin;
        },
        calculateLineTotal(estimateItem, discount, price, tax) {
            let amount = 0;
            let priceAndFee = estimateItem.print_on_estimate
                ? parseFloat(price) + parseFloat(estimateItem.fee)
                : 0;

            if (estimateItem.print_on_estimate) {
                if (estimateItem.item) {
                    if (
                        estimateItem.item.type == CITEMTYPES.TYPES.TYPE_DISCOUNT
                    ) {
                        amount = parseFloat(discount);
                    } else {
                        amount =
                            parseFloat(priceAndFee) -
                            parseFloat(discount) +
                            parseFloat(tax || 0);
                    }
                } else {
                    amount =
                        parseFloat(priceAndFee) -
                        parseFloat(discount) +
                        parseFloat(tax || 0);
                }
            } else {
                amount = 0;
            }

            return amount;
        },
        displayDiscount(estimateItem) {
            if (
                estimateItem.discount_max != 0 &&
                estimateItem.discount_max != null &&
                estimateItem.quantity_max > 0
            ) {
                if (estimateItem.discount_min == estimateItem.discount_max) {
                    return this._toCurrency(
                        round(estimateItem.discount_min, 2)
                    );
                } else {
                    return `${this._toCurrency(
                        round(estimateItem.discount_min, 2)
                    )} - ${this._toCurrency(
                        round(estimateItem.discount_max, 2)
                    )}`;
                }
            } else {
                return this._toCurrency(round(estimateItem.discount_min, 2));
            }
        },
        calculatePrice(price, fee, discount) {
            return price + fee - discount;
        },
        reloadRelated() {
            this.getEstimateItems();
            this.$emit("reset-bulk-remove", false);
            this.$emit("reload-estimate-details", null);
        },
        declinedItem(estimateItem) {
            this.$refs.modalDeclineItem.open(estimateItem);
        },
        editItem(estimateItem) {
            let copiedEstimateItem = { ...estimateItem };
            copiedEstimateItem.date = this._toDateTime(copiedEstimateItem.date);
            this.$refs.estimateItemModal.open(copiedEstimateItem);
        },
        deleteItem(estimateItem) {
            this.$refs.modalDeleteEstimateItem.open(estimateItem);
        },
        async itemSorted() {
            const params = {
                id: this.estimate.id,
                status: 1,
                data: this.estimateItems.map(invItem => invItem.id)
            };

            await EstimateItemService.updateEstimateItemOrder(params)
                .then(res => {
                    if (res.code != 200) {
                        throw "Error: Cannot reorder invoice item";
                    }
                })
                .catch(error => {
                    this._message(error, "danger");
                });
        },
        bulkDecline() {
            this.$refs.modalBulkDecline.open();
        },
        bulkDelete() {
            this.$refs.modalBulkDelete.open();
        }
    }
};
</script>
